import React, { useEffect, useState } from "react";
import Layout, { PageHeader } from "../components/Layout";
import api, { formatApiError } from "../lib/api";
import StatusBadge from "../components/StatusBadge";
import { Card } from "../components/ui/card";
import { toast } from "sonner";
import { CheckCircle, XCircle, Warning } from "@phosphor-icons/react";

export default function Orders() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/orders");
        setItems(data.items || []);
      } catch (e) {
        toast.error(formatApiError(e.response?.data?.detail));
      } finally { setLoading(false); }
    })();
  }, []);

  return (
    <Layout>
      <PageHeader eyebrow="History" title="Orders" description="All domain purchase attempts and their outcomes." />
      {loading ? <div className="overline">Loading…</div> : items.length === 0 ? (
        <Card className="p-12 text-center border-dashed" data-testid="orders-empty">
          <div className="overline mb-2">No Orders</div>
          <div className="text-sm text-muted-foreground">Purchase domains from the Buy Domains page.</div>
        </Card>
      ) : (
        <div className="space-y-3">
          {items.map((o) => (
            <Card key={o.order_id} className="p-5" data-testid={`order-${o.order_id}`}>
              <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
                <div>
                  <div className="font-mono text-xs text-muted-foreground">#{o.order_id}</div>
                  <div className="text-xs text-muted-foreground">{new Date(o.created_at).toLocaleString()}</div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="font-mono text-sm">${(o.total_cost || 0).toFixed(2)}</div>
                  <StatusBadge variant={o.purchase_status === "success" ? "success" : o.purchase_status === "partial" ? "warning" : "danger"}>
                    {o.purchase_status}
                  </StatusBadge>
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-1.5 text-xs">
                {(o.results || []).map((r) => (
                  <div key={r.domain} className="flex items-center justify-between border border-border rounded-md px-3 py-1.5">
                    <span className="font-mono">{r.domain}</span>
                    {r.success
                      ? <StatusBadge variant="success" icon={CheckCircle}>registered</StatusBadge>
                      : <StatusBadge variant="danger" icon={XCircle}>failed</StatusBadge>}
                  </div>
                ))}
              </div>
            </Card>
          ))}
        </div>
      )}
    </Layout>
  );
}
